module.exports = __webpack_public_path__ + "img/boodil-pay-by-bank.cbad5b33.png";